export enum ScheduleStatus {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
  MISSED = 'MISSED',
  CANCELLED = 'CANCELLED',
}

export enum ScheduleEventType {
  PROGRAM = 'PROGRAM',
  WORKOUT = 'WORKOUT',
  NUTRITION_PLAN = 'NUTRITION_PLAN',
  MEAL = 'MEAL',
}

// F12 — `GET /v2/auth/me/schedules` perspective: 'client' (default,
// back-compat) only returns/decorates rows the way it always has; 'all'
// additionally flags each row with `viewerRole` so the FE can also surface
// trainer-side events (sessions the caller runs for their own clients).
export enum SchedulePerspective {
  CLIENT = 'client',
  ALL = 'all',
}

// F12 — additive per-row field on `GET /v2/auth/me/schedules?perspective=all`,
// computed from trainerId/clientId at request time (no schema/migration).
export enum ScheduleViewerRole {
  CLIENT = 'client',
  TRAINER = 'trainer',
}
